import React from "react";
import AirlinesSelect from "../AirlinesSelect";
import styles from "../PageHeader/PageHeader.module.css";

import PropTypes from "prop-types";

export const PageHeader=({showselect, image, heading, para, firstfooter, secondfooter})=> {
        
    return (
        <div className={styles.container}>
            <div className={styles.row}>
                
                {showselect && (
                    <div className={styles.selectContainer}>
                        <AirlinesSelect options={[
                            {
                            label: "UPS",
                            children: (
                                <div>
                                <p></p>
                                </div>
                            ),
                            },
                            {
                            label: "AA",
                            children: (
                                <div>
                                <p></p>
                                </div>
                            ),
                            },
                        ]}
                        />
                    </div>
                )}
                <div className={styles.BodyContainer}>
                    <div className={`${styles.DescriptionContainer}`}>
                        <h1 className={styles.Heading}>{heading}</h1>
                        <p className={styles.Para}>{para}</p>
                        <p className={styles.FirstFooter}>{firstfooter}</p>
                        <p className={styles.SecondFooter}>{secondfooter}</p>
                    </div>
                    <div className={`${styles.ImageContainer}`}>
                        <img className={styles.Image} src={image} alt="Bidpro Product view" />
                    </div>
                </div>
            </div>
        </div>
    )
}

PageHeader.propTypes = {    
    showselect: PropTypes.bool,
    image: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
    para: PropTypes.string.isRequired,
    firstfooter: PropTypes.node,  
    secondfooter: PropTypes.node  
};